// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__HAXWZ","colCheckbox":"styles_colCheckbox__1rPod"};